﻿import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { StorageService } from "@app/services/storage.service";

export interface IProfileImageFilter {
    (path: string): string;
}

@NgFilter({
    token: Token.ProfileImageFilter,
    dependencies: [
        Token.StorageService
    ]
})
export class ProfileImageFilter {
    constructor(
        storageService: StorageService
    ) {
        return ((path: string) => {
            if (!path) {
                return storageService.getFallbackImage();
            } else {
                return storageService.getProfileImageUrl(path);
            }
        }) as IProfileImageFilter as any;
    }

}
